import {
  DECREMENT_LIMIT,
  DecrementLimitAction,
  UPDATE_LIMITS,
  updateLimits,
  UpdateLimitsAction
} from 'js/actionCreators/limitActions';
import { ExistingScribeModel, Limits } from 'js/types';
import { call, put, CallEffect, PutEffect, takeEvery, select, SelectEffect } from 'redux-saga/effects';
import { appServices } from 'js/shared/helpers/app-services/AppServices';
import { AUTH_SUCCESS } from 'js/actionCreators/authActions';
import { GET_VIDEO_DOWNLOAD_URL_SUCCESS } from 'js/actionCreators/downloadActions';
import {
  GENERATE_SCRIPT_SUCCESS,
  IMAGE_GENERATION_SUCCESS,
  VOICEOVER_GENERATION_SUCCESS
} from 'js/actionCreators/aiFeaturesActions';
import { LIMITS } from 'js/config/consts';
import { trackHitUsageLimit } from 'js/actionCreators/trackingActions';
import { getAllUsageLimits } from 'js/selectors/usageLimits';

import getProjectFromPathname from './sagaHelpers/getProjectFromPathname';

export function* checkIfLimitsHaveBeenHitAfterServerSideUpdate({
  limits: newLimits,
  prevLimits
}: UpdateLimitsAction): Generator<PutEffect | CallEffect | SelectEffect, void, ExistingScribeModel | Limits> {
  const project = (yield call(getProjectFromPathname)) as ExistingScribeModel;

  for (const limitType of Object.keys(LIMITS) as Array<LIMITS>) {
    const hasActiveLimit = prevLimits[limitType].limit != null && prevLimits[limitType].limit > 0;
    const hasHitLimit =
      newLimits[limitType].limit !== null &&
      newLimits[limitType].count >= newLimits[limitType].limit &&
      newLimits[limitType].count !== prevLimits[limitType].count;

    if (hasActiveLimit && hasHitLimit) {
      yield put(trackHitUsageLimit(limitType, project.id));
    }
  }
}

export function* checkIfLimitsHitOnClientSideUpdate({
  limitType
}: DecrementLimitAction): Generator<PutEffect | CallEffect | SelectEffect, void, ExistingScribeModel | Limits> {
  const project = (yield call(getProjectFromPathname)) as ExistingScribeModel;
  const currentStateLimits = (yield select(getAllUsageLimits)) as Limits;

  const hasActiveLimit = currentStateLimits[limitType].limit !== null && currentStateLimits[limitType].limit > 0;
  const hasHitLimit =
    currentStateLimits[limitType].limit !== null &&
    currentStateLimits[limitType].count >= currentStateLimits[limitType].limit;

  if (hasActiveLimit && hasHitLimit) {
    yield put(trackHitUsageLimit(limitType, project.id));
  }
}

export function* fetchAndUpdateLimits(): Generator<CallEffect | PutEffect | SelectEffect, void, Limits> {
  try {
    const prevStateLimits = yield select(getAllUsageLimits);
    const limits = yield call(appServices.getLimits);
    yield put(updateLimits(limits, prevStateLimits));
  } catch (error) {
    console.error('Error fetching and updating limits:', error);
  }
}

export default function* limitSagas() {
  yield takeEvery(AUTH_SUCCESS, fetchAndUpdateLimits);
  yield takeEvery(GET_VIDEO_DOWNLOAD_URL_SUCCESS, fetchAndUpdateLimits);
  yield takeEvery(IMAGE_GENERATION_SUCCESS, fetchAndUpdateLimits);
  yield takeEvery(VOICEOVER_GENERATION_SUCCESS, fetchAndUpdateLimits);
  yield takeEvery(GENERATE_SCRIPT_SUCCESS, fetchAndUpdateLimits);
  yield takeEvery(DECREMENT_LIMIT, checkIfLimitsHitOnClientSideUpdate);
  yield takeEvery(UPDATE_LIMITS, checkIfLimitsHaveBeenHitAfterServerSideUpdate);
}
